








import Vue from "vue";
import Component from "vue-class-component";
import Main from "@/components/template/Main.vue";
import { LoginUserStore, CompaniesStore, DepartmentsStore } from "../store";
import AmplifyEventBus from "@/common/AmplifyEventBus";
import * as CONSTANTS from "@/common/constants";
import Utils from "@/common/utils";

@Component({
  components: { Main },
})
export default class Index extends Vue {
  private isDisplay = false;

  get lastName() {
    return LoginUserStore.getLoginUser && LoginUserStore.getLoginUser.last_name
      ? LoginUserStore.getLoginUser.last_name
      : "";
  }
  get firstName() {
    return LoginUserStore.getLoginUser && LoginUserStore.getLoginUser.first_name
      ? LoginUserStore.getLoginUser.first_name
      : "";
  }
  created() {
    try {
      AmplifyEventBus.$on("authState", async (info: any) => {
        try {
          if (info === "signedOut") {
            if (this.$store && typeof this.$store.state === "object")
              Object.keys(this.$store.state).forEach(async (key) => {
                await this.$store.dispatch(`${key}/init`);
              });
            if (this.$router.currentRoute.name !== CONSTANTS.ROUTE_NAME.LOGIN) {
              this.$router.push({
                name: CONSTANTS.ROUTE_NAME.LOGIN,
              });
            }
          }
        } catch (e) {
          console.error(e);
        }
      });

      LoginUserStore.fetchLoginUser().then(async () => {
        try {
          await CompaniesStore.fetchCompanies(
            LoginUserStore.getLoginUser.user_id
          );
          await DepartmentsStore.fetchDepartments(
            LoginUserStore.getLoginUser.user_id
          );
        } catch (e) {
          console.error(e);
          await Utils.logout();
        } finally {
          this.isDisplay = true;
        }
      });
    } catch (e) {
      console.error(e);
      Utils.logout().then(() => {
        // Nothing.
      });
    }
  }
}
